import React from 'react'
import { AssessementContext } from '../../../AssessmentContext';

/* Shown when the server closed the attempt because the pipeline ended */
const AssessmentEndedModal = () => {
  const { assessment, setAssessment } = React.useContext(AssessementContext)

  const viewResults = () => {
    // Hand over to the completed flow, which waits for grading and opens the results
    setAssessment({ ...assessment, isEnded: false, isCompleted: true, savedAnswers: [], questionNumber: 0 })
  }

  return (
    <div className='h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.3)] fixed top-0 left-0' style={{ zIndex: 9000000 }}>
      <div className='w-full h-full flex items-center justify-center'>
        <div className='bg-white w-[94%] md:w-[35%] rounded-lg'>
          <h5 className='py-5 px-3 mb-5 shadow-lg text-xl'>
            Assessment ended
          </h5>
          <div className='w-[80%] mx-auto my-4'>
            <p className='flex justify-center'>
              <span className='text-[100px] bi bi-clock-history text-red-500'>
              </span>
            </p>
            <p className='text-xl text-center mt-3'>
              This assessment has ended. Your saved answers have been submitted.
            </p>
          </div>
          <div className='flex justify-center border-t border-gray-200 mt-5 px-3 py-3'>
            <button
              onClick={viewResults}
              className='bg-red-500 py-3 px-16 rounded-lg text-white text-lg'
            >
              View results
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssessmentEndedModal
